<template>
   <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card p-0">
            <div class="flex flex-col gap-2 px-4 py-5 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Order Details</h6>
                </div>
            </div>

            <div class="p-4">
                <div class="mb-6">
                    <h6 class="mb-2">Customer Details</h6>
                    <div class="grid grid-cols-2 md:grid-cols-3 gap-1">
                        <div>
                            <p class="font-semibold">Name</p>
                            <p>{{ customer.name || customer.customer_name || order.customer_name || '-' }}</p>
                        </div>
                        <div>
                            <p class="font-semibold">Contact</p>
                            <p>{{ customer.contact_number || customer.phone || order.contact_number || '-' }}</p>
                        </div>
                        <div>
                            <p class="font-semibold">Address</p>
                            <p>{{ customer.address || order.address || '-' }}</p>
                        </div>
                    </div>
                </div>
                
                <!-- Order header -->
                <div class="mb-4 grid grid-cols-2 md:grid-cols-2 gap-4">
                    <div>
                        <p class="font-semibold">Order Number: <span class="font-normal">{{ order.invoiceno || order.orderNumber || '-' }}</span></p>
                        <p class="font-semibold">Order Date: <span class="font-normal">{{ order.entry_date || order.date || '-' }}</span></p>
                    </div>
                    <div class="text-right md:text-left">
                        <p class="font-semibold">Status: <span class="font-normal">{{ last_status }}</span></p>
                        <!--<p class="font-semibold">Total: <span class="font-normal">{{ formatCurrency(orderTotal) }}</span></p>-->
                    </div>
                </div>

                <!-- Order items -->
                <div class="mb-6">
                    <h6 class="mb-2">Order Items</h6>
                    <div class="overflow-x-auto scrollbar-table">
                        <table class="table-auto w-full text-left text-gray-500 dark:text-dark-text leading-none">
                            <thead class="border-b font-semibold">
                                <tr>
                                    <th class="px-3 py-2">Item</th>
                                    <th class="px-3 py-2">Full</th>
                                    <th class="px-3 py-2">Half</th>
                                    <th class="px-3 py-2">Pant</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(it, idx) in items" :key="idx" class="border-b">
                                    <td class="px-3 py-2">{{  it.stitching_label   }}</td>
                                    <td class="px-3 py-2">{{  it.original_full_shirt   }}</td>
                                    <td class="px-3 py-2">{{  it.original_half_shirt }}</td>
                                    <td class="px-3 py-2">{{  it.original_pant  }}</td> 
                                </tr>
                                <tr v-if="items.length == 0">
                                    <td colspan="4" class="px-3 py-6 text-center text-gray-400">No items found</td>
                                </tr>
                            </tbody>
                        </table>
                        <hr>
                        <br>
                        <h3>Logs / History</h3>
                        <br>
                         <table class="table-auto w-full text-left text-gray-500 dark:text-dark-text leading-none">
                            <thead class="border-b font-semibold">
                                <tr>
                                    <th class="px-3 py-2">Date</th>
                                    <th class="px-3 py-2">Status</th>
                                    <th class="px-3 py-2">Full</th>
                                    <th class="px-3 py-2">Half</th>
                                    <th class="px-3 py-2">Pant</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(it, idx) in statuses" :key="idx" class="border-b">
                                    <td class="px-3 py-2">{{  it.iddate   }}</td>
                                    <td class="px-3 py-2">{{  it.status   }}</td>
                                    <td class="px-3 py-2">{{  it.full   }}</td>
                                    <td class="px-3 py-2">{{  it.half }}</td>
                                    <td class="px-3 py-2">{{  it.pant  }}</td> 
                                </tr>
                                <tr v-if="items.length == 0">
                                    <td colspan="4" class="px-3 py-6 text-center text-gray-400">No items found</td>
                                </tr>
                            </tbody>
                        </table>
                        <br>
                        <h3>{{getStatusTotals()}}</h3>
                    </div>
                </div>

                <!-- Customer details -->
             

                <!-- Status update & WhatsApp -->
                <div class="mb-6">
                    <h6 class="mb-2">Order Status</h6>
                    <div class="flex flex-wrap items-center gap-3">
                        <select v-model="selectedStatus" class="form-input w-60">
                            <option value="">Select Status</option>
                            <option v-for="s in original_statuses" :key="s" :value="s">{{ s }}</option>
                        </select>

                        <button class="btn b-solid btn-primary-solid" @click="updateStatus">Save Status</button>

                        <button class="btn b-solid btn-success-solid" @click="sendWhatsAppReady">Send Order Ready WhatsApp</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'OrderDetails',
    data() {
        return {
            orderId: '',
            order: {},
            customer: {},
            statuses:[],
            status_result:[],
            items: [],
            last_status:'',
            original_statuses: [
                'Washing',
                'Cutting',
                'Stitching',
                'ironing',
                'packing',
                'delivered',
            ],
            selectedStatus: '',
        };
    },
    computed: {
        orderTotal() {
            if (this.order.total_amount) return this.order.total_amount;
            // fallback to summing items
            return this.items.reduce((sum, it) => {
                const qty = Number(it.qty || it.quantity || it.count || 0);
                const price = Number(it.price || it.rate || 0);
                return sum + qty * price;
            }, 0);
        },
    },
    mounted() {
        this.orderId = this.$route.query.q || this.$route.query.order || '';
        this.loadOrder();
    },
    methods: {
        loadOrder() {
            const self = this;
            if (!this.orderId) return;

            axios.post('getMeasurementOrderDetails', { invoiceno: this.orderId })
                .then(function (response) {
                    const data = response.data || {};
                    // assume response contains order, customer and items
                    self.order = data.order || data.orderDetails || {};
                    self.customer = data.customer || data.customerDetails || self.order.customer || {};
                    self.items = data.items || data.order_items || self.order.items || [];
                    self.selectedStatus = self.order.status || '';
                    self.statuses = data.statuses;
                    
                    if(self.statuses)
                        self.last_status=self.statuses[self.statuses.length-1]?.status
                        
                }) .then(function () {
                        self.status_result = self.getStatusTotals(self.responseData)
                })
                .catch(function (error) {
                    console.log('Error loading order details: ' + error);
                    self.$swal('Error loading order details');
                });
        },
         getStatusTotals() {

                    var self = this;
                
                    let result = '';
                
                    // get unique status names
                    const uniqueStatuses = [...new Set(
                        self.statuses.map(item => item.status)
                    )];
                
                    uniqueStatuses.forEach(statusName => {
                
                        let full = 0;
                        let half = 0;
                        let pant = 0;
                
                        self.statuses.forEach(item => {
                
                            if (item.status === statusName) {
                
                                full += Number(item.full);
                                half += Number(item.half);
                                pant += Number(item.pant);
                            }
                        });
                
                        result += `${statusName} full: ${full}, ${statusName} half: ${half}, ${statusName} pant: ${pant} | `;
                    });
                
                    return result.slice(0, -3);
                },
        updateStatus() {
            var self = this;
            if (!this.selectedStatus) {
                this.$swal('Please select a status');
                return;
            }

            axios.post('updateOrderStatus', { id: this.orderId, status: this.selectedStatus })
                .then(function (response) {
                    const msg = response.data.msg || 'Status updated';
                    const isSuccess = response.data.status;
                    self.$swal(msg);
                    if (isSuccess) {
                        // refresh
                        self.loadOrder();
                    }
                })
                .catch(function (error) {
                    console.log('Error updating status: ' + error);
                    self.$swal('Error updating status');
                });
        },

        sendWhatsAppReady() {
            // Build a user-friendly message and open WhatsApp link
            const contact = this.customer.contact_number || this.customer.phone || this.order.contact_number || this.order.phone;
            if (!contact) {
                this.$swal('No contact number available for this customer');
                return;
            }

            // sanitize number: remove non-digits
            let phone = String(contact).replace(/\D/g, '');
            // If local 10-digit number, assume country code 91 (India). Adjust as needed.
            if (phone.length == 10) phone = '91' + phone;

            const name = this.customer.name || this.customer.customer_name || this.order.customer_name || '';
            const orderNo = this.order.order_number || this.order.orderNumber || this.order.id || this.orderId;
            const total = this.orderTotal;
            const shop = 'Our Store';

            const message = `Dear ${name || 'Customer'}, your order ${orderNo} is ready for pickup. Total: Rs ${total}. Thank you - ${shop}`;
            const encoded = encodeURIComponent(message);

            const url = `https://wa.me/${phone}?text=${encoded}`;
            // Open in new tab
            window.open(url, '_blank');
        },

        formatCurrency(val) {
            if (val === undefined || val === null) return '-';
            const n = Number(val);
            if (isNaN(n)) return val;
            return 'Rs ' + n.toFixed(2);
        },
    },
};
</script>
